import React from 'react'
import { Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";


function NoDataLayer(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_Display = props.display;
    const inputParam_Style = props.cstyle !== null && props.cstyle !== undefined ? props.cstyle : null;
    const inputParam_Text = props.text !== null && props.text !== undefined ? props.text : t('data-lang-lbl-nodata');
    const inputParam_Class = props.className !== null && props.className !== undefined ? props.className : "";

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <>
        {
            inputParam_Display !== null && inputParam_Display !== null ?
            <>
                {
                    inputParam_Display && 
                    <Col style={ inputParam_Style } className={`text-center ${inputParam_Class}`}>
                        { inputParam_Text }
                    </Col> 
                }
            </>
            :
            <>
            </>
        }

        </>
    );
}

export default NoDataLayer;